import What from './What';

export default What;
